module.exports = __webpack_public_path__ + "img/back-bottom-medal.29ef624c.png";